
<svg :width="width" :height="width" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_16571_26349)">
    <path
      d="M21.425 14.5454L23.7171 24.6431M24.7268 29.0909L23.7171 24.6431M23.7171 24.6431L19.2013 29.0909H7.27441"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M4.52816 22.7316L9.71139 20.6558L11.4827 16.1989L12.6637 9.84935C12.6855 9.68655 12.913 9.27546 13.6478 8.93356C14.3827 8.59166 15.2662 8.7504 15.6162 8.8725L19.356 12.3525L21.5867 12.7189C23.3188 13.7445 22.3084 14.8557 21.5867 15.2831L17.9125 14.7947L16.141 13.1462L14.96 17.5421L17.9125 21.6937L17.4532 27.5548C16.246 28.5805 15.2881 27.9822 14.96 27.5548V22.7316L13.2542 19.6789L11.8763 22.7316L5.70915 25.1127C3.34716 24.9661 3.93766 23.4642 4.52816 22.7316Z"
      :stroke="color"
      stroke-width="2"
    />
    <circle cx="16.7227" cy="4" r="3.25" :stroke="color" stroke-width="1.5" />
    <path
      d="M9.79463 29.091C9.79463 30.2029 8.75074 31.2501 7.27231 31.2501C5.79389 31.2501 4.75 30.2029 4.75 29.091C4.75 27.9791 5.79389 26.9319 7.27231 26.9319C8.75074 26.9319 9.79463 27.9791 9.79463 29.091Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M27.2497 29.0912C27.2497 30.2031 26.2058 31.2503 24.7274 31.2503C23.249 31.2503 22.2051 30.2031 22.2051 29.0912C22.2051 27.9793 23.249 26.9321 24.7274 26.9321C26.2058 26.9321 27.2497 27.9793 27.2497 29.0912Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_16571_26349">
      <rect :width="width" :height="height" fill="white" />
    </clipPath>
  </defs>
</svg>
